import basket_icon from './basket_icon.png'
import logo from './logo.png'
import logp from './logp.png'
import search_icon from './search.png'

import remove_icon_red from './remove_icon_red.png'
import play_store from './play_store.png'
import linkedin_icon from './linkedin_icon.png'
import facebook_icon from './facebook_icon.png'
import twitter_icon from './twitter_icon.png'
import cross_icon from './cross_icon.png'
import selector_icon from './selector_icon.png'
import rating_starts from './rating_starts.png'
import profile_icon from './profile_icon.png'
import bag_icon from './bag_icon.png'
import cart_icon from './cart_icon.png'
import logout_icon from './logout_icon.png'
import parcel_icon from './parcel_icon.png'
import logo_new from './logo_new.png'


import icon1 from './icon1.svg'
import icon2 from './icon2.svg'
import icon3 from './icon3.svg'

export const assets = {
    logo,
    logp,
    logo_new,
    basket_icon,
    search_icon,
    rating_starts,
    remove_icon_red,
    linkedin_icon,
    facebook_icon,
    twitter_icon,
    cross_icon,
    selector_icon,
    profile_icon,
    logout_icon,
    bag_icon,
    cart_icon,
    parcel_icon,


    icon1,
    icon2,
    icon3
}

